import React, { useState } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import ConsultModal from './ConsultModal';
import { HashLink } from 'react-router-hash-link';

function NSSNavbar() {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const navLinks = [
    { name: 'Home', to: '/#home' },
    { name: 'About', to: '/#about' },
    { name: 'Services', to: '/#services' },
    { name: 'Contact', to: '/#contact' },
  ];

  return (
    <>
      <Navbar
        expand="lg"
        collapseOnSelect
        style={{
          backgroundColor: '#7d94a6ff',
          padding: '15px 0',
          position: 'sticky',
          top: 0,
          zIndex: 999,
        }}
      >
        <Container>
          <Navbar.Brand as={HashLink} smooth to="/#home">
            <img src="./logo.png" alt="Logo" height="50" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mx-auto text-center">
              {navLinks.map((link, idx) => (
                <Nav.Link
                  key={idx}
                  as={HashLink}
                  smooth
                  to={link.to}
                  className="nav-item-link"
                  style={{
                    color: 'white',
                    fontWeight: 'bold',
                    margin: '0 10px',
                    transition: 'color 0.3s',
                  }}
                >
                  {link.name}
                </Nav.Link>
              ))}
            </Nav>
            <div className="text-center mt-3 mt-lg-0">
              <Button
                variant="warning"
                onClick={handleShow}
                className="consult-btn"
              >
                <i className="bi bi-telephone-fill me-2"></i> Consult Now
              </Button>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <ConsultModal show={showModal} handleClose={handleClose} />

      {/* Additional CSS for hover and responsive */}
      <style jsx>{`
        .nav-item-link:hover {
          color: #e07a5f !important;
        }

        .consult-btn {
          background-color: #e07a5f;
          color: #f4f1de;
          font-weight: bold;
          padding: 10px 20px;
          border-radius: 50px;
          border: 2px solid #e07a5f;
          transition: all 0.3s ease;
        }

        .consult-btn:hover {
          background-color: #f4f1de;
          color: #0d1b2a;
          border-color: #f4f1de;
        }

        @media (max-width: 991px) {
          .nav-item-link {
            display: block;
            margin: 10px 0 !important;
          }

          .consult-btn {
            width: 100%;
          }
        }

        @media (max-width: 576px) {
          .navbar-brand img {
            height: 40px;
          }
          .consult-btn {
            padding: 8px 15px;
            font-size: 0.9rem;
          }
        }
      `}</style>
    </>
  );
}

export default NSSNavbar;
